import {PropsWithChildren} from "react";
import {css} from "@panda/css";

export const VendorContainer = (props: PropsWithChildren) => {
    return <div className={containerStyle}>{props.children}</div>;
};

const containerStyle = css({
    paddingLeft: 1.5,
    paddingRight: 1.5,
    md: {
        maxWidth: "118.2rem",
        paddingLeft: 2,
        paddingRight: 2,
        marginLeft: "auto",
        marginRight: "auto"
    }
});
import {PropsWithChildren} from "react";
import {css} from "@panda/css";

export const VendorContainer = (props: PropsWithChildren) => {
    return <div className={containerStyle}>{props.children}</div>;
};

const containerStyle = css({
    paddingLeft: 1.5,
    paddingRight: 1.5,
    md: {
        maxWidth: "118.2rem",
        paddingLeft: 2,
        paddingRight: 2,
        marginLeft: "auto",
        marginRight: "auto"
    }
});
